import { Link, NavLink } from 'react-router';
import { Logo } from '@/components/common/Logo';
import { Brand } from '@/constants/brand';
import { FooterNavigation } from '@/constants/navigation';
import { Routes } from '@/constants/routes';
import { cn } from '@/lib/utils';

const CurrentYear = new Date().getFullYear();

function getFooterLinkClassName({ isActive }) {
  return cn(
    'rounded-sm text-[0.9375rem] font-medium underline-offset-4 transition-colors hover:text-graphite hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-graphite',
    isActive ? 'text-graphite underline decoration-redline decoration-2' : 'text-steel'
  );
}

export function Footer() {
  return (
    <footer className="border-t border-grid bg-paper">
      <div className="section-container grid gap-10 py-12 sm:py-14 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-start lg:gap-16">
        <div className="max-w-sm">
          <Link
            to={Routes.home}
            aria-label={`${Brand.name} home`}
            className="inline-flex rounded-md focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-graphite"
          >
            <Logo />
          </Link>
          <p className="mt-4 text-[0.9375rem] leading-relaxed text-steel">{Brand.description}</p>
        </div>
        <nav aria-label="Footer">
          <ul className="grid grid-cols-2 gap-x-10 gap-y-3 sm:flex sm:flex-wrap sm:gap-x-8">
            {FooterNavigation.map((navigationLink) => (
              <li key={navigationLink.to}>
                <NavLink to={navigationLink.to} end className={getFooterLinkClassName}>
                  {navigationLink.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className="border-t border-grid">
        <p className="section-container py-5 text-sm text-steel">
          &copy; {CurrentYear} {Brand.name}. All rights reserved.
        </p>
      </div>
    </footer>
  );
}